// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.c-validation {
   font-weight: normal;
   font-size: 0.8125em;
   line-height: 1.3em;
   margin-top: -5px;
   margin-left: 12px;
   margin-right: 10px;
   color: red;
}
`, "",{"version":3,"sources":["webpack://./src/app/e-form/form-generate/field-type/choice/choice.component.css"],"names":[],"mappings":"AAAA;GACG,mBAAmB;GACnB,mBAAmB;GACnB,kBAAkB;GAClB,gBAAgB;GAChB,iBAAiB;GACjB,kBAAkB;GAClB,UAAU;AACb","sourcesContent":[".c-validation {\n   font-weight: normal;\n   font-size: 0.8125em;\n   line-height: 1.3em;\n   margin-top: -5px;\n   margin-left: 12px;\n   margin-right: 10px;\n   color: red;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
